import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StoreService } from '@morningstar/shared/base/base-service';
import { ReportExplanation } from 'apps/wsg/src/app/admin/report-explanation/report-explanation';
import { ReportExplanationIconSelectors } from './report-explanation-icon.selectors';

@Injectable()
export class ReportExplanationIconService extends StoreService {

  constructor(protected httpClient: HttpClient, snackbar: MatSnackBar,
              @Inject('API_BASE_URL') protected baseUrl: string) {
    super(httpClient, baseUrl, snackbar);
  }

  getReportExplanation(name: string) {
    const endpoint = `admin/report-explanation/${name}`;

    this.read<ReportExplanation>(ReportExplanationIconSelectors.reportExplanation, endpoint)
        .subscribe();
  }
}
